import { isBrowser } from 'common/constants/config';
import { FRONT_CRASH, FRONT_WARN } from 'common/constants/service-errors';
import { t } from 'common-translation/tools';
import React, { Fragment } from 'react';

import logger from '../../helpers/logger';
// import { reportPlus } from '../../helpers/report';
import { getErrorPageContent } from './ErrorPageContent';

const styles = `
body { min-height: auto }
`;

export default class ErrorPage extends React.PureComponent {
  render() {
    const { code, backUrl, backBtnMsg, err } = this.props; // msg, detail, notHitRoute,
    const reqId = err?.reqId;
    const ErrorPageContent = getErrorPageContent(code);

    if (isBrowser) {
      // 上报数据前端报错数据
      // reportPlus({
      //   name: 'front_error',
      //   jKey: { eType: 'error', code },
      //   jValue: { num: 1 },
      //   jData: { reqId },
      // });

      // TAM上报错误
      if (window && window.globalAegis) {
        const level = code === 500 ? FRONT_CRASH : FRONT_WARN;
        window.globalAegis.error({
          front_error: {
            reqId,
            code,
            level,
          },
        });
      }
    } else {
      if (code !== '404') {
        logger.error('Error', { code, ...err });
      }
    }

    function submitTicket() {
      location.href = '/login?s_url=https%3A%2F%2Fconsole.cloud.tencent.com%2Fworkorder';
    }

    function goToHome() {
      location.href = backUrl || '/';
    }

    return [
      <style key="style" dangerouslySetInnerHTML={{ __html: styles }} />,
      <Fragment key="box">
        <div className="com-none-panel page">
          <div className="com-none-panel-object">
            <i className={`com-none-panel-icon ${ErrorPageContent.icon}`} />
          </div>
          <div className="com-none-panel-main">
            <h3 className="com-none-panel-title">{ErrorPageContent.title}</h3>
            <div className="com-none-panel-desc">
              <p>
                {ErrorPageContent.desc}
                {reqId && ` ( REQ_ID: ${reqId} ) `}
              </p>
            </div>
            <div className="com-none-panel-btns">
              <button className="c-btn " onClick={submitTicket}>
                <span className="text">{t('Submit Ticket')}</span>
              </button>
              <button className="c-btn c-btn-hole" onClick={() => goToHome(backUrl)}>
                <span className="text">{backBtnMsg || t('Go to Home Page')}</span>
              </button>
            </div>
          </div>
        </div>
      </Fragment>,
    ];
  }
}
